import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiKeyResponseDto } from '../../../common/model/dto/api-key';
import { RecordColumn } from '../../../common/model/ui/record-list.type';
import { OrderBy } from '../../../common/types';
import OvRecordList from './OvRecordList';

interface OvApiKeyListProps {
  apiKeys: ApiKeyResponseDto[];
  columns: RecordColumn<ApiKeyResponseDto>[];
  getNavigationState: () => unknown;
  orderBy: string;
  orderDir: string;
  onSort: (order: OrderBy) => void;
}

const OvApiKeyList: FC<OvApiKeyListProps> = ({
  apiKeys,
  columns,
  getNavigationState,
  orderBy,
  orderDir,
  onSort,
}) => {
  const { t } = useTranslation();

  return (
    <OvRecordList
      label={t('common.apiKeys')}
      records={apiKeys}
      columns={columns}
      getKey={(apiKey) => apiKey.id as string}
      getDetailsPath={(apiKey) => `/api-keys/detail/${apiKey.id}`}
      getNavigationState={getNavigationState}
      orderBy={orderBy}
      orderDir={orderDir}
      onSort={onSort}
    />
  );
};

export default OvApiKeyList;
